<template>
    <div class="anarchive-loader bg-white fixed top-0 left-0 z-10 flex flex-col w-full h-full items-center overflow-hidden sm:flex-row">
        <div class="w-full flex-1 relative z-10 sm:h-full">
            <TransitionFade>
                <div v-show="isAllLoaderImagesLoaded" class="absolute left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-0 top-1/3 flex gap-32 sm:top-0 h-full">
                    <OrganismImagesLoading :events="this.isMobile ? events.slice(0,4) : events.slice(0,3)" class="sm:-pt-10"/>
                    <OrganismImagesLoading :events="events.slice(3,6)" class="hidden sm:flex pt-24"/>
                </div>
            </TransitionFade>
        </div>

        <div class="h-fit w-full sm:w-fit p-6">
            <MoleculeAnarchiveTitle class="-z-10 p-10 sm:p-32"/>
            <div class="flex flex-col justify-between items-center gap-8">
                 <span>
                    Chargement
                </span>
                <span class="material-symbols-outlined animate-spin">
                    progress_activity
                </span>
            </div>
        </div>

        <div class="w-full flex-1 relative z-10 sm:h-full">
            <TransitionFade>
                <div v-show="isAllLoaderImagesLoaded" class="absolute left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 top-12 flex gap-32 sm:top-0 h-full">
                    <OrganismImagesLoading :events="events.slice(6,9)" class="hidden sm:flex sm:pt-32"/>
                    <OrganismImagesLoading :events="this.isMobile ? events.slice(8,12) : events.slice(9,12)" class="sm:-pt-24" isDown/>
                </div>
            </TransitionFade>
        </div>
    </div>
</template>

<script>
import AtomIconButton from "../../global/atoms/AtomIconButton.vue";
import OrganismBottomToggle from "./OrganismBottomToggle.vue";
import OrganismImageHover from "./OrganismImageHover.vue";
import MoleculeAnarchiveTitle from "../../global/molecules/MoleculeAnarchiveTitle.vue";
import OrganismImagesLoading from "./OrganismImagesLoading.vue";
import TransitionFade from "../../../transitions/TransitionFade.vue";
import ImageLoading from "../../../mixins/image-loading";
import ScreenSize from "../../../mixins/screen-size";
import {mapState} from "vuex";

export default {
    name: "OrganismLoadingScreen",
    mixins: [ImageLoading, ScreenSize],
    components: {
        TransitionFade,
        OrganismImagesLoading, MoleculeAnarchiveTitle, OrganismImageHover, OrganismBottomToggle, AtomIconButton},
    data() {
        return {
            isAllLoaderImagesLoaded: false,
        }
    },
    mounted() {
        this.awaitImagesLoading('.anarchive-loader').then(() => {
            this.isAllLoaderImagesLoaded = true;
        })
    },
    computed: {
        ...mapState('event', {
            events: 'anarchiveEvents',
        }),
    }
}
</script>

<style scoped>
.bg-green {
    background-color: #00FF00;
}
.bg-red {
    background-color: #FF0000;
}
</style>
